import script from "./audios.vue?vue&type=script&setup=true&lang=ts"
export * from "./audios.vue?vue&type=script&setup=true&lang=ts"

import "./audios.vue?vue&type=style&index=0&id=24374f9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24374f9f"]])

export default __exports__